import { render, staticRenderFns } from "./DistrictView.vue?vue&type=template&id=d3e7d7ec&scoped=true&"
import script from "./DistrictView.vue?vue&type=script&lang=js&"
export * from "./DistrictView.vue?vue&type=script&lang=js&"
import style0 from "./DistrictView.vue?vue&type=style&index=0&id=d3e7d7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e7d7ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VIcon})
